module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger.36100cb8.svg";